// Owner Filter
export const owner = {
    computed: {
        owners() {
            return this.$store.getters.getOwner.map(owner => {
                return {
                    id: owner.id,
                    value: owner.full_name
                }
            })
        }
    },

    watch: {
        'owners.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'owner_is') option.push(...this.owners)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getOwner')
        },1000)
    }
}


// Restorer Filter
export const restorer = {
    computed: {
        restorers() {
            return this.$store.getters.getRestorer.map(restorer => {
                return {
                    id: restorer.id,
                    value: restorer.name
                }
            })
        }
    },

    watch: {
        'restorers.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'restorer_is') option.push(...this.restorers)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getRestorer')
        },1000)
    }
}

// Inrest Filter
export const inrest = {
    computed: {
        inrests() {
            return this.$store.getters.getInrest.map(inrest => {
                return {
                    id: inrest.id,
                    value: inrest.name
                }
            })
        }
    },

    watch: {
        'inrests.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'inrest_is') option.push(...this.inrests)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getInrest')
        },1000)
    }
}

// Zal Filter
export const zal = {
    computed: {
        zals() {
            return this.$store.getters.getZal.map(zal => {
                return {
                    id: zal.id,
                    value: zal.name
                }
            })
        }
    },

    watch: {
        'zals.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'zal_is') option.push(...this.zals)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getZal')
        },1000)
    }
}

// Inv Filter
export const inv = {
    computed: {
        invs() {
            return this.$store.getters.getInv.map(inv => {
                return {
                    id: inv.id,
                    value: inv.name
                }
            })
        }
    },

    watch: {
        'invs.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'inv_is') option.push(...this.invs)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getInv')
        },1000)
    }
}


// Tago Filter
export const tago = {
    computed: {
        tagos() {
            return this.$store.getters.getYesno.map(tago => {
                return {
                    id: tago.id,
                    value: tago.name
                }
            })
        }
    },

    watch: {
        'tagos.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'tago_is') option.push(...this.tagos)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getYesno')
        },1000)
    }
}

// Photo Filter
export const photo = {
    computed: {
        photos() {
            return this.$store.getters.getYesno.map(photo => {
                return {
                    id: photo.id,
                    value: photo.name
                }
            })
        }
    },

    watch: {
        'photos.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'photo_is') option.push(...this.photos)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getYesno')
        },1000)
    }
}

// Desc Filter
export const desc = {
    computed: {
        descs() {
            return this.$store.getters.getYesno.map(desc => {
                return {
                    id: desc.id,
                    value: desc.name
                }
            })
        }
    },

    watch: {
        'descs.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'desc_is') option.push(...this.descs)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getYesno')
        },1000)
    }
}

// Table Filter
export const table = {
    computed: {
        tables() {
            return this.$store.getters.getYesno.map(table => {
                return {
                    id: table.id,
                    value: table.name
                }
            })
        }
    },

    watch: {
        'tables.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'table_is') option.push(...this.tables)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getYesno')
        },1000)
    }
}

// Fulltext Filter
export const fulltext = {
    computed: {
        fulltexts() {
            return this.$store.getters.getYesno.map(fulltext => {
                return {
                    id: fulltext.id,
                    value: fulltext.name
                }
            })
        }
    },

    watch: {
        'fulltexts.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'fulltext_is') option.push(...this.fulltexts)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getYesno')
        },1000)
    }
}


// Pay Filter
export const pay = {
   computed: {
        pays() {
            return this.$store.getters.getPay.map(pay => {
                return {
                    id: pay.id,
                    value: pay.name
                }
            })
        }
    },

    watch: {
        'pays.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'pay_is') option.push(...this.pays)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getPay')
        },1000)
    }
}




// Type Filter
export const contactType = {
    computed: {
        contactTypes() {
            return this.$store.getters.contentType.map(type => {
                return {
                    id: type.id,
                    class: type.class,
                    value: type.name
                }
            })
        }
    },
    watch: {
        'contactTypes.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'contact_type') option.push(...this.contactTypes)
                })
            },
            immediate: true
        }
    },
    mounted() {
      setTimeout(()=>{
        this.$store.dispatch('contentType')
      },1000)
    }
}

// CostType Filter
export const costType = {
    computed: {
        costTypes() {
            return this.$store.getters.costType.map(type => {
                return {
                    id: type.id,
                    value: type.name
                }
            })
        }
    },
    watch: {
        'costTypes.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'cost_type') option.push(...this.costTypes)
                })
            },
            immediate: true
        }
    },
    mounted() {
      setTimeout(()=>{
        this.$store.dispatch('costType')
      },1000)
    }
}
// Type Filter
export const ganttType = {
    computed: {
        ganttTypes() {
            return this.$store.getters.ganttType.map(type => {
                return {
                    id: type.id,
                    value: type.name
                }
            })
        }
    },
    watch: {
        'ganttTypes.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'gantt_type') option.push(...this.ganttTypes)
                })
            },
            immediate: true
        }
    },
    mounted() {
      setTimeout(()=>{
        this.$store.dispatch('ganttType')
      },1000)
    }
}


// Warehouse Type Filter
export const WarehouseTypeList = {
    computed: {
        WarehouseTypes() {
            return this.$store.getters.WarehouseType.map(type => {
                return {
                    id: type.id,
                    value: type.name
                }
            })
        }
    },
    watch: {
        'WarehouseTypes.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'warehouse_type') option.push(...this.WarehouseTypes)
                })
            },
            immediate: true
        }
    },
    mounted() {
      setTimeout(()=>{
        this.$store.dispatch('WarehouseType')
      },1000)
    }
}

// Type Filter
export const fundType = {
    computed: {
        fundTypes() {
            return this.$store.getters.contfundType.map(type => {
                return {
                    id: type.id,
                    class: type.class,
                    value: type.name
                }
            })
        }
    },
    watch: {
        'fundTypes.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'fund_type') option.push(...this.fundTypes)
                })
            },
            immediate: true
        }
    },
    mounted() {
      setTimeout(()=>{
        this.$store.dispatch('contfundType')
      },1000)
    }
}

// Type Filter
export const manneType = {
    computed: {
        manneTypes() {
            return this.$store.getters.manneType.map(type => {
                return {
                    id: type.id,
                    value: type.name
                }
            })
        }
    },
    watch: {
        'manneTypes.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'manne_type') option.push(...this.manneTypes)
                })
            },
            immediate: true
        }
    },
    mounted() {
      setTimeout(()=>{
        this.$store.dispatch('manneType')
      },1000)
    }
}
// Type Filter
export const manneCate = {
    computed: {
        manneCates() {
            return this.$store.getters.manneCate.map(type => {
                return {
                    id: type.id,
                    value: type.name
                }
            })
        }
    },
    watch: {
        'manneCates.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'manne_cate') option.push(...this.manneCates)
                })
            },
            immediate: true
        }
    },
    mounted() {
      setTimeout(()=>{
        this.$store.dispatch('manneCate')
      },1000)
    }
}





// Status Filter
export const status = {
    computed: {
        statuses() {
            return this.$store.getters.getStatus.map(status => {
                return {
                    id: status.id,
                    value: status.translated_name
                }
            })
        }
    },
    watch: {
        'statuses.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'status') option.push(...this.statuses)
                })
            },
            immediate: true
        }
    },
    mounted() {
        this.$store.dispatch('getStatus')
    }
}

// Proposal Status Filter
export const proposalStatus = {
    computed: {
        statusProposal() {
            return this.$store.getters.getProposalStatus.map(status => {
                return {
                    id: status.id,
                    value: status.translated_name
                }
            })
        }
    },
    watch: {
        'statusProposal.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'status') option.push(...this.statusProposal)
                })
            },
            immediate: true
        }
    },
    mounted() {
        this.$store.dispatch('getProposalStatus')
    }
}

// Deal Status Filter
export const dealStatus = {
    computed: {
        statusDeal() {
            return this.$store.getters.getDealStatus.map(status => {
                return {
                    id: status.id,
                    value: status.translated_name
                }
            })
        }
    },
    watch: {
        'statusDeal.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'status') option.push(...this.statusDeal)
                })
            },
            immediate: true
        }
    },
    mounted() {
        setTimeout(() => {
          this.$store.dispatch('getDealStatus')
        }, 1000)
    }
}

// Tags Filter
export const tag = {
    computed: {
        tags() {
            return this.$store.getters.getAllTags.map(tag => {
                return {
                    id: tag.id,
                    value: tag.name
                }
            })
        }
    },
    watch: {
        'tags.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'tags') option.push(...this.tags)
                })
            },
            immediate: true
        }
    },
    mounted() {

        setTimeout(() => {
          this.$store.dispatch('getAllTags')
        }, 1000)
    }

}

// Organization Filter
export const organization = {
    computed: {
        organizations() {
            return this.$store.getters.getOrganization.map(organization => {
                return {
                    id: organization.id,
                    value: organization.name
                }
            })
        }
    },
    watch: {
        'organizations.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'organization') option.push(...this.organizations)
                })
            },
            immediate: true
        }
    },

    mounted() {
        this.$store.dispatch('getOrganization')
    }
}

// Argon Filter
export const argon = {
    computed: {
        argons() {
            return this.$store.getters.getArgon.map(argon => {
                return {
                    id: argon.id,
                    value: argon.name
                }
            })
        }
    },
    watch: {
        'argons.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'argon') option.push(...this.argons)
                })
            },
            immediate: true
        }
    },

    mounted() {
        this.$store.dispatch('getArgon')
    }
}

// Person Filter
export const person = {
    computed: {
        persons() {
            return this.$store.getters.getPerson.map(person => {
                return {
                    id: person.id,
                    value: person.name
                }
            })
        }
    },
    watch: {
        'persons.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'person') option.push(...this.persons)
                })
            },
            immediate: true
        }
    },
    mounted() {

        setTimeout(() => {
          this.$store.dispatch('getPerson')
        }, 1000)
    }
}

// Fund Filter
export const fund = {
    computed: {
        funds() {
            return this.$store.getters.getFund.map(fund => {
                return {
                    id: fund.id,
                    value: fund.name
                }
            })
        }
    },
    watch: {
        'funds.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'fund') option.push(...this.funds)
                })
            },
            immediate: true
        }
    },
    mounted() {

        setTimeout(() => {
          this.$store.dispatch('getFund')
        }, 1000)
    }
}

// Frund Filter
export const frund = {
    computed: {
        frunds() {
            return this.$store.getters.getFrund.map(frund => {
                return {
                    id: frund.id,
                    value: frund.name
                }
            })
        }
    },
    watch: {
        'frunds.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'frund') option.push(...this.frunds)
                })
            },
            immediate: true
        }
    },
    mounted() {

        setTimeout(() => {
          this.$store.dispatch('getFrund')
        }, 1000)
    }
}
// Eve Filter
export const eve = {
    computed: {
        eves() {
            return this.$store.getters.getEve.map(eve => {
                return {
                    id: eve.id,
                    value: eve.name
                }
            })
        }
    },
    watch: {
        'eves.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'eve') option.push(...this.eves)
                })
            },
            immediate: true
        }
    },
    mounted() {

        setTimeout(() => {
          this.$store.dispatch('getEve')
        }, 1000)
    }
}

// Pipeline Filter
export const pipeline = {
    computed: {
        pipelines() {
            return this.$store.getters.getPipeline.map(pipeline => {
                return {
                    id: pipeline.id,
                    value: pipeline.name
                }
            })
        }
    },
    watch: {
        'pipelines.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'pipeline') option.push(...this.pipelines)
                })
            },
            immediate: true
        }
    },
    mounted() {

        setTimeout(() => {
          this.$store.dispatch('getPipeline')
        }, 1000)
    }
}

// Activity Types Filter
export const activityType = {
    computed: {
        activityType() {
            return this.$store.getters.getActivityType.map(activityType => {
                return {
                    id: activityType.id,
                    value: activityType.name
                }
            })
        }
    },
    watch: {
        'activityType.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'activity_type') option.push(...this.activityType)
                })
            },
            immediate: true
        }
    },
    mounted() {
        this.$store.dispatch('getActivityType')
    }
}

// Deal Filter
export const deal = {
    computed: {
        deal() {
            return this.$store.getters.getDeal.map(deal => {
                return {
                    id: deal.id,
                    value: deal.title
                }
            })
        }
    },
    watch: {
        'deal.length': {
            handler: function (length) {
                this.options.filters.find(({key, option}) => {
                    if (key === 'deal') option.push(...this.deal)
                })
            },
            immediate: true
        }
    },
    mounted() {
        this.$store.dispatch('getDeal')
    }
}
